import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MarketingHeader from "@/components/marketing/Header";
import MarketingFooter from "@/components/marketing/Footer";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function NewsPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setMissing(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white">
      <MarketingHeader />
      <article className="max-w-3xl mx-auto px-6 py-20">
        <Link to="/news" className="inline-flex items-center gap-1 text-sm text-teal-600 font-medium mb-8">
          <ArrowLeft className="h-4 w-4" /> All news
        </Link>
        {missing && <p className="text-slate-500" data-testid="post-not-found">This post could not be found.</p>}
        {post && (
          <>
            <div className="text-xs text-slate-400">{new Date(post.created_at).toLocaleDateString()}</div>
            <h1 className="font-display text-4xl sm:text-5xl font-light text-[#0a2540] mt-3 leading-tight" data-testid="post-title">
              {post.title}
            </h1>
            <div className="mt-10 text-slate-700 leading-relaxed whitespace-pre-wrap text-lg" data-testid="post-body">
              {post.body}
            </div>
          </>
        )}
      </article>
      <MarketingFooter />
    </div>
  );
}
